export default {"src":"/login-app/[GIT_HASH]/_next/static/media/account_tree.80a7497d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};